import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import Image from '../../components/AppImage';

import ContactSection from '../../components/ContactSection';

const OurCabs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const vehicles = [
  {
    name: 'Innova Crysta 7+1',
    bags: 6,
    seats: 7,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17142d727-1768366661943.png",
    imageAlt: 'Toyota Innova Crysta 7 seater variant with driver seat for group travel'
  },
  {
    name: 'Kia Carens',
    bags: 5,
    seats: 6,
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_10c28221a-1768075340455.png',
    imageAlt: 'Kia Carens premium MPV with modern styling and comfortable interiors'
  },
  {
    name: 'Urbania',
    bags: 9,
    seats: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
    imageAlt: 'Force Urbania luxury van for group travel with spacious seating'
  },
  {
    name: 'Brezza',
    bags: 4,
    seats: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16b493177-1768380107788.png",
    imageAlt: 'Maruti Brezza compact SUV in urban setting with modern design'
  },
  {
    name: 'Tempo Traveller',
    bags: 15,
    seats: 25,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    imageAlt: 'Tempo Traveller 25 seater for large group travel and tours'
  },
  {
    name: 'Force Urbania',
    bags: 16,
    seats: 16,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
    imageAlt: 'Force Urbania 16 seater luxury van with premium features'
  },
  {
    name: 'Innova Hycross',
    bags: 5,
    seats: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_128b5b542-1768145556724.png",
    imageAlt: 'Toyota Innova Hycross latest model with hybrid technology'
  },
  {
    name: 'Fortuner',
    bags: 5,
    seats: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1eff652-1765364969211.png",
    imageAlt: 'Toyota Fortuner luxury SUV with premium features and comfort'
  },
  {
    name: 'Tempo Traveller',
    bags: 15,
    seats: 17,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    imageAlt: 'Tempo Traveller 17 seater for group travel and tours'
  },
  {
    name: 'Maruti Ertiga',
    bags: 4,
    seats: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cecda4a3-1768145557954.png",
    imageAlt: 'Maruti Ertiga MPV with spacious seating capacity'
  },
  {
    name: 'Tempo Traveller',
    bags: 8,
    seats: 12,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6efb5fd-1765716730341.png",
    imageAlt: 'Tempo Traveller 12 seater for medium group travel'
  },
  {
    name: 'Innova Crysta',
    bags: 6,
    seats: 6,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b3582ff-1764720422661.png",
    imageAlt: 'Toyota Innova Crysta luxury MPV in silver color'
  },
  {
    name: 'Maruti Dzire',
    bags: 3,
    seats: 4,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bc20140d-1768380108457.png",
    imageAlt: 'White Maruti Dzire sedan car with sleek design'
  }];


  const handleSelectCar = (vehicle) => {
    navigate('/vehicle-details', {
      state: {
        vehicle: vehicle
      }
    });
  };

  return (
    <>
      <SEO
        title="Our Vehicles - Advait Tour and Travels | Premium Cab Fleet"
        description="Explore our premium fleet of vehicles including Innova Crysta, Kia Carens, Urbania, Brezza, Tempo Traveller, Fortuner, and more. Book the perfect cab for your journey."
        keywords="our vehicles, cab fleet, innova crysta, kia carens, urbania, tempo traveller, fortuner, brezza, maruti dzire, advait tour and travels fleet"
        canonicalUrl={`${window.location?.origin}/our-cabs`}
        ogTitle="Our Vehicles - Advait Tour and Travels"
        ogDescription="Explore our premium fleet of vehicles for all your travel needs."
        ogUrl={`${window.location?.origin}/our-cabs`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Our Vehicles - Advait Tour and Travels",
          "description": "Explore our premium fleet of vehicles for all your travel needs."
        }} />

      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Our Vehicles
              </h1>
            </div>
          </div>

          {/* Vehicle Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
              {vehicles?.map((vehicle, index) =>
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">

                  {/* Icons at top */}
                  <div className="flex items-center justify-end gap-4 p-4 pb-0">
                    <div className="flex items-center gap-1">
                      <Icon name="Briefcase" size={18} className="text-gray-700" />
                      <span className="text-base font-semibold text-gray-800">{vehicle?.bags}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Icon name="Users" size={18} className="text-gray-700" />
                      <span className="text-base font-semibold text-gray-800">{vehicle?.seats}</span>
                    </div>
                  </div>

                  {/* Image */}
                  <div className="aspect-video overflow-hidden px-4">
                    <Image
                    src={vehicle?.image}
                    alt={vehicle?.imageAlt}
                    className="w-full h-full object-contain" />

                  </div>

                  {/* Content */}
                  <div className="p-4 pt-2">
                    <h3 className="text-lg font-bold text-gray-800 mb-4 text-center">
                      {vehicle?.name}
                    </h3>
                    <button
                    onClick={() => handleSelectCar(vehicle)}
                    className="w-full py-2.5 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-colors duration-300">

                      Select Car
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Contact Section with Blue Background */}
          <ContactSection />
        </main>

        <Footer />
      </div>
    </>);


};

export default OurCabs;